export enum HazardPermissionsEnum {
  ANIANatRiskIndex = "RMA_RISK_INDEX_ITA_ANIA_CURCL_NATEVE",
  ANIANonCatRiskIndex = "RMA_RISK_INDEX_ITA_ANIA_CURCL_NNATCA",
  SeismicRiskHowden = "RMA_RISK_EARTH_ITA_RMSHOW_NATCAT",

  InlandFloodHowden = "RMA_RISK_RIVFL_ITA_RMSHOW_NATCAT",
  InlandFloodHowden58 = "RMA_RISK_RIVFL_ITA_RMSHOW_NATCAT58",
  InlandFloodHowden56 = "RMA_RISK_RIVFL_ITA_RMSHOW_NATCAT56",
  InlandFloodHowden202410 = "RMA_RISK_RIVLF_ITA_RMSHOW_NATCAT202410",

  LandslideRiskIspra = "CYS_RISK_LSLDE_ITA_ISPRA",
  InlandFloodIspra = "CYS_RISK_RIVFL_ITA_ISPRA",
  SeismicRiskIspra = "CYS_RISK_EARTH_ITA_ISPRA",

  EarthquakeMagnitude = "CYS_RISK_EARTH_MAG_ITA",
  SeismicClassificationIta = "CYS_RISK_EARTH_ITA_DDPC",

  InlandFloodEur10y = "CYS_RISK_RIVFL_EUR_EFAS_CURCL_RP0010",
  InlandFloodEur20y = "CYS_RISK_RIVFL_EUR_EFAS_CURCL_RP0020",
  InlandFloodEur30y = "CYS_RISK_RIVFL_EUR_EFAS_CURCL_RP0030",
  InlandFloodEur40y = "CYS_RISK_RIVFL_EUR_EFAS_CURCL_RP0040",
  InlandFloodEur50y = "CYS_RISK_RIVFL_EUR_EFAS_CURCL_RP0050",
  InlandFloodEur75y = "CYS_RISK_RIVFL_EUR_EFAS_CURCL_RP0075",
  InlandFloodEur100y = "CYS_RISK_RIVFL_EUR_EFAS_CURCL_RP0100",
  InlandFloodEur200y = "CYS_RISK_RIVFL_EUR_EFAS_CURCL_RP0200",
  InlandFloodEur500y = "CYS_RISK_RIVFL_EUR_EFAS_CURCL_RP0500",

  InlandFloodIta10y = "CYS_RISK_RIVFL_ITA_EFAS_CURCL_RP0010",
  InlandFloodIta20y = "CYS_RISK_RIVFL_ITA_EFAS_CURCL_RP0020",
  InlandFloodIta30y = "CYS_RISK_RIVFL_ITA_EFAS_CURCL_RP0030",
  InlandFloodIta40y = "CYS_RISK_RIVFL_ITA_EFAS_CURCL_RP0040",
  InlandFloodIta50y = "CYS_RISK_RIVFL_ITA_EFAS_CURCL_RP0050",
  InlandFloodIta75y = "CYS_RISK_RIVFL_ITA_EFAS_CURCL_RP0075",
  InlandFloodIta100y = "CYS_RISK_RIVFL_ITA_EFAS_CURCL_RP0100",
  InlandFloodIta200y = "CYS_RISK_RIVFL_ITA_EFAS_CURCL_RP0200",
  InlandFloodIta500y = "CYS_RISK_RIVFL_ITA_EFAS_CURCL_RP0500",

  InlandFloodUsa10y = "CYS_RISK_RIVFL_USA_EFAS_CURCL_RP0010",
  InlandFloodUsa20y = "CYS_RISK_RIVFL_USA_EFAS_CURCL_RP0020",
  InlandFloodUsa50y = "CYS_RISK_RIVFL_USA_EFAS_CURCL_RP0050",
  InlandFloodUsa75y = "CYS_RISK_RIVFL_USA_EFAS_CURCL_RP0075",
  InlandFloodUsa100y = "CYS_RISK_RIVFL_USA_EFAS_CURCL_RP0100",
  InlandFloodUsa200y = "CYS_RISK_RIVFL_USA_EFAS_CURCL_RP0200",
  InlandFloodUsa500y = "CYS_RISK_RIVFL_USA_EFAS_CURCL_RP0500",

  InlandFloodBra10y = "CYS_RISK_RIVFL_BRA_EFAS_CURCL_RP0010",
  InlandFloodBra20y = "CYS_RISK_RIVFL_BRA_EFAS_CURCL_RP0020",
  InlandFloodBra50y = "CYS_RISK_RIVFL_BRA_EFAS_CURCL_RP0050",
  InlandFloodBra75y = "CYS_RISK_RIVFL_BRA_EFAS_CURCL_RP0075",
  InlandFloodBra100y = "CYS_RISK_RIVFL_BRA_EFAS_CURCL_RP0100",
  InlandFloodBra200y = "CYS_RISK_RIVFL_BRA_EFAS_CURCL_RP0200",
  InlandFloodBra500y = "CYS_RISK_RIVFL_BRA_EFAS_CURCL_RP0500",

  InlandFloodGlobal10y = "CYS_RISK_RIVFL_WRL_GLOFAS_CURCL_RP0010",
  InlandFloodGlobal20y = "CYS_RISK_RIVFL_WRL_GLOFAS_CURCL_RP0020",
  InlandFloodGlobal50y = "CYS_RISK_RIVFL_WRL_GLOFAS_CURCL_RP0050",
  InlandFloodGlobal100y = "CYS_RISK_RIVFL_WRL_GLOFAS_CURCL_RP0100",
  InlandFloodGlobal500y = "CYS_RISK_RIVFL_WRL_GLOFAS_CURCL_RP0500",

  CoastalFlood10y = "CYS_RISK_CSTFL_EUR_EURAIN_RCP45_RP0010",
  CoastalFlood30y = "CYS_RISK_CSTFL_EUR_EURAIN_RCP45_RP0030",
  CoastalFlood100y = "CYS_RISK_CSTFL_EUR_EURAIN_RCP45_RP0100",
  CoastalFlood300y = "CYS_RISK_CSTFL_EUR_EURAIN_RCP45_RP0300",
  CoastalFlood1000y = "CYS_RISK_CSTFL_EUR_EURAIN_RCP45_RP1000",
  CoastalFloodEurProt = "CYS_RISK_CSTFL_EUR_EURAIN_RCP45_RP1000_WP",
  CoastalFloodEurNoProt = "CYS_RISK_CSTFL_EUR_EURAIN_RCP45_RP1000_NP",
  FlashFloodIta3h = "CYS_RISK_FLAFL_EUR_EURAIN_CURCL_RP0010_3HR",
  FlashFloodIta24h = "CYS_RISK_FLAFL_EUR_EURAIN_CURCL_RP0010_24HR",
  FlashFloodIta48h = "CYS_RISK_FLAFL_EUR_EURAIN_CURCL_RP0010_48HR",
  FlashFloodIta72h = "CYS_RISK_FLAFL_EUR_EURAIN_CURCL_RP0010_72HR",
  HailEurLarge = "CYS_RISK_HAILS_EUR_EURAIN_CURCL_LARGE",
  HailItaLarge = "CYS_RISK_HAILS_ITA_EURAIN_CURCL_LARGE",
  HailItaLargeRcp45 = "CYS_RISK_HAILS_ITA_EURAIN_RCP45_LARGE",
  HailItaLargeRcp85 = "CYS_RISK_HAILS_ITA_EURAIN_RCP85_LARGE",
  HailItaExLarge = "CYS_RISK_HAILS_ITA_EURAIN_CURCL_EXLARGE",
  HailItaExLargeRcp45 = "CYS_RISK_HAILS_ITA_EURAIN_RCP45_EXLARGE",
  HailItaExLargeRcp85 = "CYS_RISK_HAILS_ITA_EURAIN_RCP85_EXLARGE",
  ExplosionIta = "CYS_RISK_EXPLO_ITA_ISPRA",
  HighWindItaSevere = "CYS_RISK_WINDY_ITA_EURAIN_CURCL_SEVERE",
  HighWindItaSevereRcp45 = "CYS_RISK_WINDY_ITA_EURAIN_RCP45_SEVERE",
  HighWindItaSevereRcp85 = "CYS_RISK_WINDY_ITA_EURAIN_RCP85_SEVERE",
  HighWindItaExtreme = "CYS_RISK_WINDY_ITA_EURAIN_CURCL_EXSEVERE",
  HighWindItaExtremeRcp45 = "CYS_RISK_WINDY_ITA_EURAIN_RCP45_EXSEVERE",
  HighWindItaExtremeRcp85 = "CYS_RISK_WINDY_ITA_EURAIN_RCP85_EXSEVERE",
  SnowIta5cm = "CYS_RISK_SNOWF_ITA_EURAIN_RCP45_5CM",
  SnowIta25cm = "CYS_RISK_SNOWF_ITA_EURAIN_RCP45_25CM",
  LightningStrikeIta = "CYS_RISK_LGTNG_ITA_NLDN_CURCL",
  WindItaANIA = "RMA_RISK_WINDY_ITA_ANIA",
  HailItaANIA = "RMA_RISK_HAILS_ITA_ANIA",
  LightningStrikeItaANIA = "RMA_RISK_LGTNG_ITA_ANIA",
  PrecipitationIta75mmANIA = "RMA_RISK_PRECP_ITA_ANIA",
  SnowIta30cmANIA = "RMA_RISK_SNOWF_ITA_ANIA",
  WarningLandslide = "CYS_NOWC_LSLDE_WRL_NASAGPM",
  WarningRainfall1Day = "CYS_WARN_RAINF_ITA_1DAY",
  WarningRainfall7Day = "CYS_WARN_RAINF_ITA_7DAY",
  RealeGroupWind = "RMA_RISK_WINDY_ITA_RMANAT_CURCL",
  RealeGroupHail = "RMA_RISK_HAILS_ITA_RMANAT_CURCL",

  SeismicCoCoRma = "RMA_RISK_EARTH_ITA_COCO",
  SeismicCoCo2Rma = "RMA_RISK_EARTH_ITA_COCO_2",
  SeismicCoCo3Rma = "RMA_RISK_EARTH_ITA_COCO_3",
  SeismicCoCo4Rma = "RMA_RISK_EARTH_ITA_COCO_4",

  SeismicCoCoIta = "ITA_RISK_EARTH_ITA_COCO",
  SeismicCoCo2Ita = "ITA_RISK_EARTH_ITA_COCO_2",
  SeismicCoCo3Ita = "ITA_RISK_EARTH_ITA_COCO_3",
  SeismicCoCo4Ita = "ITA_RISK_EARTH_ITA_COCO_4",

  FloodCoCoRma = "RMA_RISK_RIVFL_ITA_COCO",
  FloodCoCo2Rma = "RMA_RISK_RIVFL_ITA_COCO_2",
  FloodCoCo3Rma = "RMA_RISK_RIVFL_ITA_COCO_3",

  FloodCoCoIta = "ITA_RISK_RIVFL_ITA_COCO",
  FloodCoCo2Ita = "ITA_RISK_RIVFL_ITA_COCO_2",
  FloodCoCo3Ita = "ITA_RISK_RIVFL_ITA_COCO_3",

  LandslideCoCoIta = "ITA_RISK_LSLDE_ITA_COCO",
  LandslideCoCo2Ita = "ITA_RISK_LSLDE_ITA_COCO_2",
  LandslideCoCo3Ita = "ITA_RISK_LSLDE_ITA_COCO_3",

  LandslideCoCoRma = "RMA_RISK_LSLDE_ITA_COCO",
  LandslideCoCo2Rma = "RMA_RISK_LSLDE_ITA_COCO_2",
  LandslideCoCo3Rma = "RMA_RISK_LSLDE_ITA_COCO_3",

  LandslideTodayPrc = "CYS_RISK_LSLDE_ITA_PRC_TODAY",
  ThunderstormTodayPrc = "CYS_RISK_WINDY_ITA_PRC_TODAY",
  FloodTodayPrc = "CYS_RISK_RIVFL_ITA_PRC_TODAY",
  LandslideTomorrowPrc = "CYS_RISK_LSLDE_ITA_PRC_TOMORROW",
  ThunderstormTomorrowPrc = "CYS_RISK_WINDY_ITA_PRC_TOMORROW",
  FloodTomorrowPrc = "CYS_RISK_RIVFL_ITA_PRC_TOMORROW",
  SeismicRiskHowden2 = "RMA_RISK_EARTH_ITA_RMSHOW_NATCAT2",
  SeismicRiskGemIsl = "CYS_RISK_EARTH_ISL_GEM_NATCAT",
  SeismicRiskGemGlobal = "CYS-RISK-EARTH-WRL-GEM-NATCAT",
  StormSurgeCat1Us = "CYS_RISK_STORM_USA_CURCL_CAT1",
  WildfireVHPIndexUs = "CYS_RISK_WILDF_USA_VHP_INDEX",
  EnvironmentDistanceFireStation = "CYS_SOCE_DFIRES",
  EnvironmentDistanceSchool = "CYS_SOCE_DSCHOOLS",
  LandCoverCropTypeEur2023 = "CYS_ENVR_LANDC_EUR_CLMS_V2023",
  LandCoverForestTypeEur2023 = "CYS_ENVR_LANDF_EUR_CLMS_V2023",
  WorldCover2021 = "CYS_ENVR_LANDC_WRL_ESA_V2021",
  DigitalElevationModelSwe = "CYS_ENVR_DEM_SWE_COPERNICUS_GLO30",
  DigitalElevationModelIta = "CYS_ENVR_DEM_ITA_COPERNICUS_GLO30",
  HeightAboveNearestDrainageSwe = "CYS_ENVR_HAND_SWE_ASF_COPWORLDDEM30",
  HeightAboveNearestDrainageIta = "CYS_ENVR_HAND_ITA_ASF_COPWORLDDEM30",
  PopulationDensityEurStat22021 = "CYS_SOCE_POPLD_EUR_EUROSTAT_V22021",
  PopulationDensityWorld = "CYS_SOCE_POPLD_WRL_ORNL_LANDSCANG",
  PopulationDensityUsa = "CYS_SOCE_POPLD_USA_ORNL_LANDSCANUSA",
  DistanceToNearestCoastWorld = "CYS_ENVR_DCOAST_WRL_NASAOBPG",
  DistanceToNearestCoastIta = "CYS_ENVR_DCOAST_ITA_NASAOBPG",
  CrimeDatasetsSwe = "CYS_SOCE_CRIME_SWE_MSB_2024",
  NasaCastPrecipitationIta1Day = "CYS_NOWC_PRECP_ITA_NASAGPM_1DAY",
  NasaCastPrecipitationIta3Day = "CYS_NOWC_PRECP_ITA_NASAGPM_3DAY",
  NasaCastPrecipitationIta7Day = "CYS_NOWC_PRECP_ITA_NASAGPM_7DAY",
  NasaCastLandslideIta = "CYS_NOWC_LSLDE_ITA_NASAGPM",
}
